import { render } from "./ModalUploadWalletCSV.vue?vue&type=template&id=2fbe78ae&scoped=true"
import script from "./ModalUploadWalletCSV.vue?vue&type=script&lang=js"
export * from "./ModalUploadWalletCSV.vue?vue&type=script&lang=js"

import "./ModalUploadWalletCSV.vue?vue&type=style&index=0&id=2fbe78ae&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbe78ae"]])

export default __exports__